/* Local cart interaction fallback when the theme's remote controller is unavailable. */
(() => {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.open === 'function') return;
  const abort = new AbortController();
  const signal = abort.signal;
  let activeElement, busy = false;
  const root = window.Shopify?.routes?.root || '/';
  const methods = {
    setActiveElement(el) { activeElement = el; },
    getSectionsToRender() { return [{id:'cart-drawer'}]; },
    open(el) {
      if (el) activeElement = el;
      drawer.classList.add('active','animate');
      document.body.classList.add('overflow-hidden');
      drawer.querySelector('.drawer__inner')?.focus();
    },
    close() {
      drawer.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
      if (activeElement?.isConnected) activeElement.focus();
    },
    renderContents(data) {
      const html = data.sections?.['cart-drawer'];
      if (!html) throw new Error(window.nuashapeI18n.dynamic_022);
      const parsed = new DOMParser().parseFromString(html,'text/html').querySelector('cart-drawer');
      if (!parsed) throw new Error(window.nuashapeI18n.dynamic_022);
      drawer.innerHTML = parsed.innerHTML;
      drawer.classList.toggle('is-empty',parsed.classList.contains('is-empty'));
      methods.open();
    }
  };
  Object.assign(drawer, methods);
  async function change(input, quantity) {
    if (busy) return;
    const line = input.closest('.cart-item')?.dataset.index;
    if (!line || !Number.isInteger(quantity) || quantity < 0) return;
    busy = true; drawer.setAttribute('aria-busy','true');
    const old = Number(input.defaultValue);
    try {
      const response = await fetch(root+'cart/change.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(line),quantity,sections:['cart-drawer'],sections_url:location.pathname})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || window.nuashapeI18n.dynamic_025);
      if (!data.sections?.['cart-drawer']) {
        const sectionResponse = await fetch(root+'?sections=cart-drawer');
        data.sections = await sectionResponse.json();
      }
      methods.renderContents(data);
    } catch(error) {
      input.value = old;
      const status = drawer.querySelector('#CartDrawer-CartErrors');
      if(status) status.textContent = error.message;
    } finally { busy = false; drawer.removeAttribute('aria-busy'); }
  }
  drawer.addEventListener('click', event => {
    const target = event.target;
    if(target.closest('.drawer__close') || target.id === 'CartDrawer-Overlay') {event.preventDefault();methods.close();return;}
    const remove = target.closest('cart-remove-button');
    const quantityButton = target.closest('.quantity__button');
    if (!remove && !quantityButton) return;
    const input = target.closest('.cart-item')?.querySelector('.quantity__input');
    if (!input) return;
    // Prevent partially initialized theme controls from sending duplicate updates.
    event.preventDefault();event.stopImmediatePropagation();
    const step = Number(input.step) || 1;
    const quantity = remove ? 0 : Math.max(0,Number(input.value)+(quantityButton.name==='plus'?step:-step));
    change(input,quantity);
  },{capture:true,signal});
  drawer.addEventListener('change', event => {
    if (!event.target.matches('.quantity__input')) return;
    event.stopImmediatePropagation();change(event.target,Number(event.target.value));
  },{capture:true,signal});
  document.addEventListener('keydown',event=>{
    if (!drawer.classList.contains('active')) return;
    if(event.key==='Escape') {event.preventDefault();methods.close();}
    if(event.key!=='Tab') return;
    const focusable=[...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]')].filter(el=>el.getClientRects().length);
    const first=focusable[0],last=focusable.at(-1);
    if(!first)return;
    if(event.shiftKey && (document.activeElement===first || document.activeElement===drawer.querySelector('.drawer__inner'))) {event.preventDefault();last.focus();}
    else if(!event.shiftKey && (document.activeElement===last || !drawer.contains(document.activeElement))) {event.preventDefault();first.focus();}
  },{signal});
  // Hand control back if the original implementation becomes available later.
  customElements.whenDefined('cart-drawer').then(()=>{
    abort.abort();
    for(const name of Object.keys(methods)) if(drawer[name]===methods[name]) delete drawer[name];
    if(activeElement)drawer.setActiveElement?.(activeElement);
  });
})();
